export default "__VITE_ASSET__63aab852__"